import { Center } from "@mantine/core";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useSelector } from "src/redux/hooks";

import { StyledWeek } from "./styled.Week";

dayjs.extend(weekOfYear);

interface Props {
  id: string;
  value: string;
  feature?: string;
}

const Week = ({ id, value, feature }: Props) => {
  const { control, setValue } = useFormContext();
  const { features } = useSelector(state => state.generatorSlice);
  const currentDate = dayjs();
  const weekNumber = currentDate.week();
  const currentYear = currentDate.year();
  const { field } = useController({
    control,
    name: id,
    defaultValue: value || String(weekNumber),
  });
  useEffect(() => {
    if (feature && features[feature]) {
      setValue(id, features[feature]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [features, feature]);
  return (
    <Center>
      <StyledWeek {...field} />
      <p style={{ marginLeft: "5px" }}>Of {currentYear}</p>
    </Center>
  );
};

export default Week;
